import { Component, Input, OnInit } from '@angular/core';
import { ActionUserComponent } from './action-user/action-user.component';
import { ActionNavComponent } from './action-nav/action-nav.component';

import { RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { ModuloEnum } from '../../enums/modulo.enum';
import { FuncionalidadesComponent } from './funcionalidades/funcionalidades.component';
import { FuncionalidadeEnum } from '../../enums/funcionalidade.enum';
import { AuthService } from '../../services/apis/usuario-admin/auth.service';

@Component({
  selector: 'app-menu',
  imports: [ActionUserComponent, ActionNavComponent, FuncionalidadesComponent, RouterModule, MatBadgeModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
})
export class MenuComponent implements OnInit {
  public showActionUser: boolean = false;
  public showActionNav: boolean = false;
  public showActionInvite: boolean = false;
  public showActionFuncionalidade: boolean = false;
  public areThereNotifications: boolean = false;

  @Input() moduloEnum: ModuloEnum;
  @Input() funcionalidadeEnum: FuncionalidadeEnum;
  public nomeModulo: string;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    const userLoginResponse = this.authService.getUserInfos();
    this.nomeModulo = userLoginResponse.listaModulos.filter(c => c.idModulo === this.moduloEnum)[0].nome;
  }

  clickShowActionUser(action: boolean | null): void {
    if (!action) {
      this.showActionUser = !this.showActionUser;
      this.showActionNav = false;
      this.showActionInvite = false;
      this.showActionFuncionalidade = false;
      return;
    }

    this.showActionUser = action;
  }

  clickShowActionNav(action: boolean | null): void {
    if (!action) {
      this.showActionNav = !this.showActionNav;
      this.showActionUser = false;
      this.showActionInvite = false;
      this.showActionFuncionalidade = false;
      return;
    }

    this.showActionNav = action;
  }

  clickShowFuncionalidade(action: boolean | null): void {
    if (!action) {
      this.showActionFuncionalidade = !this.showActionFuncionalidade;
      this.showActionUser = false;
      this.showActionNav = false;
      this.showActionInvite = false;
      return;
    }

    this.showActionFuncionalidade = action;
  }

  clickShowActionInvites(action: boolean | null): void {
    if (!action) {
      this.showActionInvite = !this.showActionInvite;
      return;
    }

    this.showActionInvite = action;
  }

  setAreThereNotifications(areThereNotifications: boolean): void {
    this.areThereNotifications = areThereNotifications;
  }
}
